/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum CohortrendementVanafDoublure {
    ZONDER_VERTRAGING = "Zonder vertraging",
    GEDOUBLEERD = "Gedoubleerd"
}
